export default "__VITE_ASSET__DAygP43F__"